// Needed to stop sending events to Plausible after
// canceling service.

const Plausible = () => ({
  trackEvent: (event) => console.log(`NOT tracking event: ${event}`),
})

export default Plausible
